import { styled } from "utils";

const Label = styled("label", { fontWeight: "$semibold" });

export { Label };
